export default __webpack_public_path__ + "static/media/disconnect-white.3ed79233.svg";